import React from "react";

function Smarthome() {
  return (
    <div>
      <h1>Smarthome</h1>
      <p>
        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Accusamus
        saepe eos, labore laboriosam dicta distinctio libero sapiente quidem cum
        cupiditate voluptate, repudiandae odit aliquam enim excepturi voluptates
        quia! Quasi, vitae!
      </p>
    </div>
  );
}

export default Smarthome;
